"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gameStartedCommand = exports.closeOverlayCommand = exports.openOverlayCommand = exports.Overlay = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
var Overlay;
(function (Overlay) {
    Overlay[Overlay["PLAYERS"] = 0] = "PLAYERS";
    Overlay[Overlay["SHOP"] = 1] = "SHOP";
    Overlay[Overlay["SETTINGS"] = 2] = "SETTINGS";
    Overlay[Overlay["STATS"] = 3] = "STATS";
})(Overlay || (exports.Overlay = Overlay = {}));
exports.openOverlayCommand = (0, toolkit_1.createAction)("ui/openOverlay");
/**
 * With no payload, closes any open overlay. With a payload, only closes if the
 * given overlay is currently open.
 */
exports.closeOverlayCommand = (0, toolkit_1.createAction)("ui/closeOverlay", (overlay) => ({ payload: overlay }));
/** Dispatched once when a game session begins. */
exports.gameStartedCommand = (0, toolkit_1.createAction)("gameStarted");
